export default {
  carton: '箱号: ',
  ao: '订单号: ',
  sku: '产品代码: ',
  skuTip: '产品代码',
  upc: 'UPC',
  nfcUid: 'NFC UID',
  clear: '清除',
  pleaseScan: '请扫描',
  taggingAll: '需绑定所有产品',
  alreadyTag: 'NFC已被绑定',
  tagSuccess: '绑定成功',
  cartonDoesNotExist: '箱号不存在于波次列表中',
  skuDoesNotExist: '产品在箱号列表中不存在, 请联系管理员',
  cartonAlreadyTag: '箱子产品已被绑定',
  cartonDoesNotIncludeNFCSKU: '箱号不包含NFC产品',
  errorcode_417: 'NFC Uid 已经存在',
  errorcode_419: '不是NFC产品',
  errorcode_903: '需绑定所有产品',
  errorcode_4171: 'NFC Uid 必须唯一',
  errorcode_439: '当前客户端不是工作台',
  errorcode_433: '参数不能为空',
  errorcode_416: 'NFC Uid 不能为空',
  errorcode_901: '箱号中不存在SKU',
  errorcode_902: '缓存的产品不一样',
  errorcode_604: '该箱号已被取消。',
  submit: '提交',
  hasAllTagged: '已全部绑定',
  totalData: '数据总数: ',
  boundItems: '已绑定条数: ',
  requiredTagType: '预期的标签类型',
  actualTagType: '实际的标签类型',
  tagStatus: '绑定状态',
  action: '操作',
  salesOrder: '订单号: ',
  productCode: '产品代码'
}
